import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import { ViewEncapsulation } from '@angular/core';
import { analyzeAndValidateNgModules } from '@angular/compiler';

@Component({
  selector: 'app-units-master',
  templateUrl: './units-master.component.html',
  styleUrls: ['./units-master.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UnitsMasterComponent implements OnInit {

  units: string;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  public searchText: string;
  UnitsExport = [] as any;
  EditedUnit = [] as any;
  EditedUnitId: string;
  Status: boolean = false;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean =true;
  isShownActive: Boolean = true;

  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;

  displayedColumns: string[] = ['sno', 'Units', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;


  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    debugger
    this.vRead = localStorage.getItem('UnitsRead');
    this.vWrite = localStorage.getItem('UnitsWrite');
    // if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
    // {
    //   window.location.href = '/Dashboard';
      

    // }
     
    // if (this.vWrite != undefined && this.vWrite != "") {
    //   if (this.vWrite == "True")
    //     this.isShownWrite = false;
    // }

    this.BindUnitsGrid();
    this.BindUnitsExport();
  }

  SubmitUnits() {
    this.isShownError = true;
    this.isShownSuccess = true;   
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.Status =false;
    //var vcountrycode = this.CountryCode;
    var vUnit = this.units;
    debugger;

  

    if (vUnit == undefined || vUnit == "" || vUnit == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter A Unit.";
      return false;
    }


    let params = new HttpParams();
    params = params.append('dUnit', this.units);
    var value = this.http.get(environment.apiUrl + 'Units/InsertUnit', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var UnitFromData = data;
        this.units = "";
        this.SuccessMsg = "unitsMaster Added."  
        this.BindUnitsGrid();
        this.BindUnitsExport();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else if(vErrorMsg1 == "Success")
        {
          this.BindUnitsGrid();
          this.BindUnitsExport();
          return false;

        }
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Unit Already Exists";
          return false;
        }
        else {
        }
      });
  }
  EditUnit(item: any) {
    debugger;
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn =false;
    this.isShownActive =false;
    this.EditedUnit = item;
    var vUnitId = this.EditedUnit.unitsId;   
    var vUnit = this.EditedUnit.units;
    
    this.EditedUnitId =vUnitId;
    
    this.units = vUnit;
    var vStatus = this.EditedUnit.status;
    debugger;
    if(vStatus == "Active")
    {
      this.Status =false;
    }
    else
    {
      this.Status=true;
    }
  }


  UpdateUnit()
  {
    this.isShownError = true;
    this.isShownSuccess = true;    
    this.ErrorMsg = "";
    this.SuccessMsg = "";
  
    var vUnit = this.units;
    debugger;

    if (vUnit == undefined || vUnit == "" || vUnit == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter A Unit.";
      return false;
    }
    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    let params = new HttpParams();
    
    params = params.append('unit', this.units);
    params = params.append('iUnitId',this.EditedUnitId);
    params = params.append('status',vStatus);
    var value = this.http.get(environment.apiUrl + 'Units/UpdateUnit', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var UnitFromData = data;
        this.SuccessMsg = "UnitsMaster Updated."
        this.units = "";     
        this.Status = false;     
        this.isShownSaveBtn = false;
        this.isShownUpdateBtn =true;
        this.isShownActive = false;   
        this.BindUnitsGrid(); 
        this.BindUnitsExport();   
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });


  }
  ClearUnits() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn =true;
    this.Status=false;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.units = "";
  }


  BindUnitsGrid() {
    var value = this.http.get(environment.apiUrl + 'Units/GetUnitsForGrid').toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindUnitsExport() {
     var value = this.http.get(environment.apiUrl + 'Units/GetUnit').toPromise().then(
      (data: any) => {
        debugger;
        this.UnitsExport = data;
      }); 
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.UnitsExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'Units');

    /* save to file */
    XLSX.writeFile(wb, "Units.xlsx");

  }


}
